require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-mitch-robertson.json") })
        }
      }, "path---blog-author-mitch-robertson");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-mitch-robertson!./.cache/json/blog-author-mitch-robertson.json
// module id = 691
// module chunks = 231608221292675